import React from 'react';

export type SearchField = 'all' | 'name' | 'phone' | 'email' | 'notes';

interface ContactSearchFiltersProps {
  activeFilter: SearchField;
  onFilterChange: (filter: SearchField) => void;
}

const ContactSearchFilters: React.FC<ContactSearchFiltersProps> = ({ activeFilter, onFilterChange }) => {
  const filters: { id: SearchField; label: string }[] = [
    { id: 'all', label: 'All Fields' },
    { id: 'name', label: 'Name' },
    { id: 'phone', label: 'Phone' },
    { id: 'email', label: 'Email' },
    { id: 'notes', label: 'Notes' }
  ];

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => onFilterChange(filter.id)}
          className={`px-3 py-1 text-xs rounded-full transition-colors ${
            activeFilter === filter.id
              ? 'bg-whatsapp-green text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default ContactSearchFilters;
